import { Link } from "react-router-dom";
import { ColumnDef, createColumnHelper } from "@tanstack/react-table";
import { BatchType } from "types/payroll-types";
import TableHeader from "components/TableHeader";
import TableCell from "components/TableCell";
import Table from "components/Table";
import { useNavigate } from "react-router-dom";
import { PaginatedResponse } from "types/payroll-types";

interface BatchesDataTableType {
  tableData: BatchType[];
  tableName: string;
  paginationData: PaginatedResponse<BatchType>;
  currentPage: number;
  pageSize: number;
  getBatchesPage: (pageUrl: string, action: string) => Promise<void>;
  onPageSizeChange?: (size: number) => void;

}

const BatchesDataTable = (props: BatchesDataTableType) => {
  const {
    tableData,
    tableName,
    paginationData,
    currentPage,
    pageSize,
    onPageSizeChange,
    getBatchesPage
  } = props;
  
  const navigate = useNavigate();
  const columnHelper = createColumnHelper<BatchType>();
  
  
  const handleRowClick = (batch: BatchType) => {
    navigate(`/payslip/batch/${batch.id}`);
  };

  const handleNextPage = () => {
    if (paginationData?.next) {
      getBatchesPage(paginationData.next, "next");
    }
  };

  const handlePreviousPage = () => {
    if (paginationData?.previous) {
      getBatchesPage(paginationData.previous, "previous");
    }
  };

  const columns: ColumnDef<BatchType, any>[] = [
    columnHelper.accessor("id", {
      id: "id",
      header: () => (
        <TableHeader>ID</TableHeader>
      ),
      cell: (info: any) => (
        <TableCell>
          {info.getValue()}
        </TableCell>
      ),
    }),
    columnHelper.accessor("month", {
      id: "month",
      header: () => (
        <TableHeader>Month</TableHeader>
      ),
      cell: (info) => (
        <TableCell>
          {new Date(info.row.original.period_start).toLocaleString('default', { month: 'long' })}
        </TableCell>
      ),
    }),
    columnHelper.accessor("period_start", {
      id: "period_start",
      header: () => (
        <TableHeader>Period Start</TableHeader>
      ),
      cell: (info) => (
        <TableCell>
          {info.getValue()}
        </TableCell>
      ),
    }),
    columnHelper.accessor("period_end", {
      id: "period_end",
      header: () => (
        <TableHeader>Period End</TableHeader>
      ),
      cell: (info) => (
        <TableCell>
          {info.getValue()}
        </TableCell>
      ),
    }),
  ];
  
  const totalCount = paginationData?.count || 0;
  
  return (
    <Table<BatchType>
      tableData={tableData}
      columns={columns}
      tableHeading={tableName}
      onRowClick={handleRowClick}
      totalCount={totalCount}
      currentPage={currentPage}
      pageSize={pageSize}
      hasNextPage={!!paginationData?.next}
      hasPreviousPage={!!paginationData?.previous}
      onNextPage={handleNextPage}
      onPreviousPage={handlePreviousPage}
      onPageSizeChange={onPageSizeChange}

    />
  );
};

export default BatchesDataTable;